module.exports = __webpack_public_path__ + "img/testimonials-1.437f71cc.jpg";